// --- 客服管理 --- //

export default [{
  name: 'orderList',
  path: '/platformManagement/customerServiceManagement/orderList',
  meta: {
    title: '订单列表'
  },
  component: require('business/platformManagement/customerServiceManagement/orderList/test.vue').default
},
{
  name: 'orderDetail',
  path: '/platformManagement/customerServiceManagement/orderDetail',
  meta: {
    title: '订单详情'
  },
  component: require('business/platformManagement/customerServiceManagement/orderList/detail.vue').default
},
{
  name: 'userList',
  path: '/platformManagement/customerServiceManagement/userList',
  meta: {
    title: '用户查询'
  },
  component: require('business/platformManagement/customerServiceManagement/userList/list.vue').default
}
]
